export const toSimpleValidationErrors = (errors) => {
    return Object.keys(errors).reduce((carry, key) => ({
        ...carry,
        [key]: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
    }), {});
};
